<div class="create-branch">
  <!-- Form Container -->
  <div class="container-custom">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
      </div>
      <span class="fa fa-times close_icon" (click)="closeModal()"></span>
    </div>
    <div
      class="d-flex justify-content-between align-items-center branch-header"
    >
      <div>
        <span class="title">Create Branch</span>
      </div>
      <span class="step-info">Step 2 of 3</span>
    </div>
    <!-- <div class="row" *ngIf="organisationId && rowData && rowData.length > 0 && currentFlow">
            <span style="margin-top: 1.75rem;" class="mb-3">Existing Branch(s)</span>
            <div class="col-md-12">
                <ag-grid-angular style="width: 100%; height: 130px;" class="ag-theme-alpine" [theme]="'legacy'" [rowData]="rowData"
                    [columnDefs]="columnDefs" [modules]="modules" [animateRows]="true" [pagination]="pagination"
                    [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="false" [domLayout]="'autoHeight'"
                    [gridOptions]="gridOptions" rowDragManaged="false" animateRows="true" (gridReady)="onGridReady($event)" #agGrid>
                </ag-grid-angular>
            </div>
        </div> -->
    <confirm-dialog (confirm)="onConfirmDelete()"></confirm-dialog>
    <ng-template #cellTemplate let-value="value" let-rowData="rowData">
      <div class="action-container">
        <div class="menu-dropdown">
          <button class="btn" type="button" (click)="editRow(rowData)">
            ✏️
          </button>
          <button class="btn" type="button" (click)="deleteRow(rowData)">
            🗑️
          </button>
        </div>
      </div>
    </ng-template>
    <div class="my-4">
      <p>Please fill the below information to create an branch.</p>
    </div>
    <!-- Form Fields -->
    <form [formGroup]="branchForm" (ngSubmit)="onSubmit()">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Branch Name*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Branch Name"
            formControlName="name"
          />
          <small
            *ngIf="
              branchForm.get('name')?.invalid && branchForm.get('name')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('name')?.errors?.['required']"
              >Branch name is required.</span
            >
            <span *ngIf="branchForm.get('name')?.errors?.['maxlength']"
              >Branch name cannot exceed 50 characters.</span
            >
          </small>
        </div>
        <div class="col-md-6">
          <label class="form-label">Logo</label>
          <input
            type="file"
            class="form-control"
            (change)="onFileSelected($event)"
          />
          <div *ngIf="logoPreview" class="mt-3">
            <img
              [src]="logoPreview"
              alt="logo"
              class="img-thumbnail"
              style="width: 40px; height: 40px"
            />
          </div>
          <!-- <div *ngIf="logoError" class="text-danger">Logo is required.</div> -->
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Assign Organization(s)*</label>
          <!-- <select class="form-control" formControlName="organisation_id" >
                        <option [ngValue]="null" disabled selected *ngIf="!branchData">Select Organization</option>               
                        <option *ngFor="let org of organizationsList" [ngValue]="org.id">
                            {{ org.name }}
                        </option>
                    </select> -->
          <app-single-select-dropdown
            [list]="organizationsList"
            [displayKey]="'name'"
            [valueKey]="'id'"
            [placeholder]="'Select Organization'"
            formControlName="organisation_id"
          >
          </app-single-select-dropdown>

          <small
            *ngIf="
              branchForm.get('organisation_id')?.invalid &&
              branchForm.get('organisation_id')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="branchForm.get('organisation_id')?.errors?.['required']"
              >Organization is required.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Contact Number*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Contact Number"
            formControlName="contact_number"
          />
          <small
            *ngIf="
              branchForm.get('contact_number')?.invalid &&
              branchForm.get('contact_number')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('contact_number')?.errors?.['required']"
              >Contact number is required.</span
            >
            <span
              *ngIf="branchForm.get('contact_number')?.errors?.['maxlength']"
              >Contact number cannot exceed 50 characters.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Contact Email*</label>
          <input
            type="email"
            class="form-control"
            placeholder="Enter Email Address"
            formControlName="contact_email"
          />
          <small
            *ngIf="
              branchForm.get('contact_email')?.invalid &&
              branchForm.get('contact_email')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('contact_email')?.errors?.['required']"
              >Contact email is required.</span
            >
            <span *ngIf="branchForm.get('contact_email')?.errors?.['email']"
              >Contact email should be email type.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Branch Type*</label>
          <select
            class="form-control"
            name="branch_type"
            formControlName="branch_type"
            id=""
          >
            <option [ngValue]="null" disabled selected>
              Select Branch Type
            </option>
            <option value="CLINIC">Clinic</option>
            <option value="HOSPITAL">Hospital</option>
          </select>
 

          <small
            *ngIf="
              branchForm.get('branch_type')?.invalid &&
              branchForm.get('branch_type')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('branch_type')?.errors?.['required']"
              >Branch type is required.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Google Map Url</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter google map url"
            formControlName="branch_google_map_url"
          />
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Pincode</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter pincode"
            formControlName="pincode"
          />
          <small
            *ngIf="
              branchForm.get('pincode')?.errors?.['maxlength'] &&
              branchForm.get('pincode')?.touched
            "
            class="text-danger"
          >
            Pincode cannot exceed 6 digits.
          </small>
        </div>
        <div class="col-md-12 mt-3">
          <label class="form-label">Address*</label>
          <textarea
            class="form-control"
            placeholder="Add Branch Address"
            rows="3"
            formControlName="address"
          ></textarea>
          <small
            *ngIf="
              branchForm.get('address')?.invalid &&
              branchForm.get('address')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('address')?.errors?.['required']"
              >Address is required.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Latitude*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter latitude"
            formControlName="latitude"
          />
          <small
            *ngIf="
              branchForm.get('latitude')?.invalid &&
              branchForm.get('latitude')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('latitude')?.errors?.['required']"
              >Latitude is required.</span
            >
            <span
              *ngIf="branchForm.get('latitude')?.errors?.['decimalPrecision']"
            >
              Latitude must be a decimal number with precision 9 and scale
              6.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Longitude*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter longitude"
            formControlName="longitude"
          />
          <small
            *ngIf="
              branchForm.get('longitude')?.invalid &&
              branchForm.get('longitude')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('longitude')?.errors?.['required']"
              >Longitude is required.</span
            >
            <span
              *ngIf="branchForm.get('longitude')?.errors?.['decimalPrecision']"
            >
              Longitude must be a decimal number with precision 9 and scale
              6.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Locality*</label>
          <!-- <select name="locality_id" class="form-control" formControlName="locality_id">
                        <option [ngValue]="null" disabled selected>Select Locality</option>
                        <option *ngFor="let locality of localityList" [ngValue]="locality.id">
                            {{ locality.name }}
                        </option>
                    </select> -->

          <app-single-select-dropdown
            [list]="localityList"
            [displayKey]="'name'"
            [valueKey]="'id'"
            [placeholder]="'Select Locality'"
            formControlName="locality_id"
          >
          </app-single-select-dropdown>

          <small
            *ngIf="
              branchForm.get('locality_id')?.invalid &&
              branchForm.get('locality_id')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('locality_id')?.errors?.['required']"
              >Locality id is required.</span
            >
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label class="form-label">Time-zone*</label>
          <select
            name="timezone"
            class="form-control"
            formControlName="timezone"
            id=""
          >
            <option [ngValue]="null" >Select Time-zone</option>
            <option value="Asia/Kolkata" selected>Asia/Kolkata</option>
          </select>
  

          <small
            *ngIf="
              branchForm.get('timezone')?.invalid &&
              branchForm.get('timezone')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="branchForm.get('timezone')?.errors?.['required']"
              >Time-zone is required.</span
            >
          </small>
        </div>
      </div>

      <!-- Toggles -->
      <div class="mt-3">
        <div class="d-flex align-items-center mb-2">
          <label class="form-check-label me-2">Deleted Status</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              formControlName="deleted"
            />
          </div>
          <label class="form-check-label me-2">Is email mrd allowed</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              formControlName="is_email_mrd_allowed"
            />
          </div>
        </div>
      </div>

      <!-- <div class="mt-3">
                <div class="d-flex align-items-center mb-2">
                    <label class="form-check-label me-2">Is Email</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_email_mrd_allowed">
                    </div>
                </div>
            </div> -->

      <!-- Buttons -->
      <div class="footer-buttons mt-3 mb-2">
        <div class="d-flex align-items-center mt-5 gap-3">
          <button class="btn btn-save" type="submit">Save</button>
          <button
            class="btn btn-save"
            *ngIf="branchData?.id"
            (click)="createAnotherBranch()"
            type="button"
          >
            Create another branch
          </button>
        </div>
        <div
          class="d-flex align-items-center mt-5 gap-3"
          *ngIf="branchData?.id"
        >
          <button
            class="btn btn-outline-secondary"
            (click)="closeModal()"
            type="button"
          >
            Cancel
          </button>
          <button
            class="btn btn-create"
            type="button"
            (click)="openUserModal()"
          >
            Create User
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
